import { faCopy } from "@fortawesome/free-regular-svg-icons";
import {
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FileInputField from "../../../components/FileInputField";
import Loader from "../../../components/Loader";
import OverlayLoader from "../../../components/OverlayLoader";
import { BACKEND_URL, FRONTEND_URL } from "../../../config";
import { defaultService, SERVICE_DEFS } from "../../../constants";
import { generatePassword } from "../../../controllers/passwordGenerator";
import { setActiveTab } from "../../../redux/Actions/tabAcions";
import { getSingleUser, updateHotel } from "../../../redux/Actions/userAction";
import QRCodeGenerator from "../../QrGenerator";

const EditClientDetails = ({ clientId }) => {
  const [screenLoading, setScreenLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState({});
  const [valetLocationError, setValetLocationError] = useState(false);
  const [valetLocationName, setValetLocationName] = useState("");
  const [locationIndex, setLocationIndex] = useState(null);
  const [showValetLocations, setShowValetLocations] = useState(false);
  const [locationImageUploading, setLocationImageUploading] = useState([]);
  const [qrCodeModal, setQRCodeModal] = useState(false);
  const [newLocationData, setNewLocationData] = useState({
    locationName: "",
    hotelName: "",
    address: "",
  });
  const [serviceFor, setServiceFor] = useState("");
  const [updatedHotel, setUpdatedHotel] = useState({
    id: "",
    companyName: "",
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    location: "",
    accountStatus: false,
    services: {},
    botcopyId: "",
    qrCodes: {
      forMaids: "",
      forValets: "",
      forBellmen: "",
      forAirbnb: "",
    },
    valetLocations: [
      {
        locationName: "",
        hotelName: "",
        address: "",
        qrCode: "",
      },
    ],
  });
  const { loading, user: client } = useSelector((state) => state.singleUser);
  const {
    loading: updateLoading,
    error: updateError,
    success: updateSuccess,
  } = useSelector((state) => state.hotelUpdate);

  const dispatch = useDispatch();
  const getServiceSafe = (services, key) => services?.[key] ?? defaultService();

  const toggleServiceEnabled = (serviceKey) => {
    setUpdatedHotel((prev) => {
      const prevServices = prev.services || {};
      const current = getServiceSafe(prevServices, serviceKey);

      return {
        ...prev,
        services: {
          ...prevServices,
          [serviceKey]: {
            ...current,
            enabled: !current.enabled,
          },
        },
      };
    });
  };
  // const handleServiceCheckboxChange = (service) => {
  //   setUpdatedHotel((prevHotel) => {
  //     prevHotel.services[service] = !prevHotel.services[service];
  //     return { ...prevHotel };
  //   });
  // };
  const handleImageUpload = async (e, service) => {
    const file = e.target.files[0];
    setUploadLoading((prevState) => ({
      ...prevState,
      [service]: true, // Set loading true for that service
    }));
    try {
      const formData = new FormData();
      formData.append("qrImage", file);
      const response = await axios.post(
        `${BACKEND_URL}api/upload/qrCodes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const fileUrl = response.data.fileUrl;
      if (response.data.success) {
        setUploadLoading(false);
        setUpdatedHotel((prevHotel) => ({
          ...prevHotel,
          qrCodes: {
            ...prevHotel.qrCodes,
            [service]: fileUrl,
          },
        }));
      }
    } catch (error) {
      setUploadLoading(false);
      console.error("Error uploading the image: ", error);
    }
  };
  const handleValetLocationImageUpload = async (e, index) => {
    const file = e.target.files[0];
    const formData = new FormData();
    setLocationImageUploading((prevState) => {
      const updatedUploadingStatus = [...prevState];
      updatedUploadingStatus[index] = true;
      return updatedUploadingStatus;
    });
    formData.append("qrImage", file);
    try {
      const response = await axios.post(
        `${BACKEND_URL}api/upload/qrCodes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const fileUrl = response.data.fileUrl;
      if (response.data.success) {
        setUpdatedHotel((prevHotel) => {
          const updatedValetLocations = [...prevHotel.valetLocations];
          updatedValetLocations[index] = {
            ...updatedValetLocations[index],
            qrCode: fileUrl,
          };

          return {
            ...prevHotel,
            valetLocations: updatedValetLocations,
          };
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLocationImageUploading((prevState) => {
        const updatedUploadingStatus = [...prevState];
        updatedUploadingStatus[index] = false;
        return updatedUploadingStatus;
      });
    }
  };
  const handleCopyLoactionChatbotLink = (id, location) => {
    const link = `${FRONTEND_URL}/bot?ref=valet&hotel=${id}&location=${location}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {})
      .catch((err) => {
        console.error("Failed to copy link:", err);
      });
  };
  const handleAddNewLocation = () => {
    const { locationName, hotelName, address } = newLocationData;
    if (
      locationName.trim() !== "" &&
      hotelName.trim() !== "" &&
      address.trim() !== ""
    ) {
      setValetLocationError(false);
      setUpdatedHotel((prevHotel) => ({
        ...prevHotel,
        valetLocations: [
          ...prevHotel.valetLocations,
          { locationName, hotelName, address },
        ],
      }));
      // Clear the form
      setNewLocationData({
        locationName: "",
        hotelName: "",
        address: "",
      });
      setShowValetLocations(true);
    } else {
      setValetLocationError(true);
    }
  };
  const handleRemoveValetLocation = (indexToRemove) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this valet location?",
    );
    if (isConfirmed) {
      setUpdatedHotel((prevHotel) => {
        const updatedValetLocations = [...prevHotel.valetLocations];
        updatedValetLocations.splice(indexToRemove, 1);

        return {
          ...prevHotel,
          valetLocations: updatedValetLocations,
        };
      });
    }
  };
  const handleEdit = (sendEmail) => {
    // e.preventDefault();
    let updatedPassword = updatedHotel.password;
    let passwordGenerated = false;
    if (!updatedPassword) {
      updatedPassword = generatePassword(updatedHotel.companyName);
      passwordGenerated = true;
    }
    const isAnyServiceEnabled = Object.values(updatedHotel.services).some(
      (s) => s?.enabled,
    );
    if (isAnyServiceEnabled && !updatedHotel?.botcopyId?.trim()) {
      message.error("Botcopy bot Id is required");
      return;
    }
    dispatch(updateHotel(updatedHotel));
  };
  const handleBackButton = () => {
    dispatch(setActiveTab("#dashboard"));
  };
  const handleQRCodeModal = () => setQRCodeModal(false);

  useEffect(() => {
    dispatch(getSingleUser(clientId));
  }, [clientId]);

  useEffect(() => {
    let hideLoading;
    if (updateLoading) {
      hideLoading = message.loading("Updating", 0);
    }
    if (updateSuccess) {
      if (hideLoading) hideLoading();
      message.success("Updated!");
    }
    if (updateError) {
      if (hideLoading) hideLoading();
      message.error(updateError || "Failed to update");
    }
    return () => {
      if (hideLoading) hideLoading();
    };
  }, [updateLoading, updateSuccess, updateError]);

  useEffect(() => {
    setScreenLoading(true);
    setTimeout(() => {
      setScreenLoading(false);
    }, 1000);
    if (client != null) {
      const mapValetLocations = (locations) =>
        locations.map((location) =>
          typeof location === "string"
            ? { locationName: location, hotelName: "", address: "", qrCode: "" }
            : {
                locationName: location.locationName || "",
                hotelName: location.hotelName || "",
                address: location.address || "",
                botRef: location.botRef || "",
                botRefId: location.botRefId || "",
                qrCode: location.qrCode || "",
              },
        );
      setUpdatedHotel((prevHotel) => ({
        ...prevHotel,
        id: client._id,
        companyName: client.companyName,
        name: client.name,
        email: client.email,
        password: client.password,
        phoneNumber: client.phoneNumber,
        location: client.location,
        services: client?.services,
        botcopyId: client?.botcopyId,
        qrCodes: {
          forMaids: client.qrCodes?.forMaids,
          forValets: client.qrCodes?.forValets,
          forBellmen: client.qrCodes?.forBellmen,
          forAirbnb: client.qrCodes?.forAirbnb,
        },
        feeConfiguration: {
          percentage: client.feeConfiguration?.percentage?.$numberDecimal || "",
          cents: client.feeConfiguration?.cents?.$numberDecimal || "",
        },

        accountStatus: client.accountStatus || false,
        valetLocations: Array.isArray(client.valetLocations)
          ? mapValetLocations(client.valetLocations)
          : [],
      }));
    }
  }, [client]);

  return (
    <>
      {/* <QRCodeGenerator
        show={qrCodeModal}
        onHide={handleQRCodeModal}
        service={serviceFor}
        hotelId={updatedHotel.id}
        upload={handleImageUpload}
        valetLocationName={valetLocationName}
        locationQrUpload={handleValetLocationImageUpload}
        index={locationIndex}
      /> */}
      {loading || screenLoading ? (
        <OverlayLoader />
      ) : (
        <Row className="p-4">
          <Col className="p-0">
            <Row className="mb-1 text-primary">
              <Col
                className="hover-effect"
                xs="auto"
                onClick={handleBackButton}
              >
                <FontAwesomeIcon icon={faChevronLeft} className=" me-2" />
                <span className="fw-semibold">Dashboard</span>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col>
                <h4 className="text-primary text-center mb-4 fw-semibold">
                  Edit Details
                </h4>
                <Form>
                  <Row className="my-2">
                    <Col sm={4}>
                      <Form.Group className="" controlId="formBasicEmail">
                        <Form.Label className="fw-semibold">
                          Hotel Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={updatedHotel.companyName}
                          onChange={(e) =>
                            setUpdatedHotel({
                              ...updatedHotel,
                              companyName: e.target.value,
                            })
                          }
                          placeholder="Enter Company Name"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="" controlId="formBasicEmail">
                        <Form.Label className="fw-semibold">
                          Contact Person Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={updatedHotel.name}
                          onChange={(e) =>
                            setUpdatedHotel({
                              ...updatedHotel,
                              name: e.target.value,
                            })
                          }
                          placeholder="Enter Contact Person Name"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group className="" controlId="formBasicEmail">
                        <Form.Label className="fw-semibold">
                          Email Address
                        </Form.Label>
                        <Form.Control
                          type="email"
                          value={updatedHotel.email}
                          onChange={(e) =>
                            setUpdatedHotel({
                              ...updatedHotel,
                              email: e.target.value,
                            })
                          }
                          placeholder="Enter Email"
                        />
                        {/* <Form.Text className="text-muted fst-italic">
                          This is the login email*
                        </Form.Text> */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="my-2">
                    <Col md={4}>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label className="fw-semibold">
                          Address Line
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={updatedHotel.location}
                          onChange={(e) =>
                            setUpdatedHotel({
                              ...updatedHotel,
                              location: e.target.value,
                            })
                          }
                          placeholder="Enter Location"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label className="fw-semibold">
                          Phone Number
                        </Form.Label>
                        <Form.Control
                          type="number"
                          value={updatedHotel.phoneNumber}
                          onChange={(e) =>
                            setUpdatedHotel({
                              ...updatedHotel,
                              phoneNumber: e.target.value,
                            })
                          }
                          placeholder="Enter Phone Number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formFeeConfiguration">
                        <Form.Label className="fw-semibold">
                          Stripe Fee Formula
                        </Form.Label>
                        <Row className="align-items-center justify-content-center">
                          <Col>
                            <div className="d-flex align-items-center">
                              <Form.Control
                                type="number"
                                value={
                                  updatedHotel.feeConfiguration?.percentage ||
                                  2.9
                                }
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  setUpdatedHotel((prevHotel) => ({
                                    ...prevHotel,
                                    feeConfiguration: {
                                      ...prevHotel.feeConfiguration,
                                      percentage: e.target.value,
                                    },
                                  }))
                                }
                                placeholder="Enter percentage"
                              />
                              <span className="ms-2">%</span>
                            </div>
                          </Col>
                          <Col md={1}>+</Col>
                          <Col>
                            <div className="d-flex align-items-center">
                              <span className="me-2">$</span>
                              <Form.Control
                                type="number"
                                value={
                                  updatedHotel.feeConfiguration?.cents || 0.3
                                }
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  setUpdatedHotel((prevHotel) => ({
                                    ...prevHotel,
                                    feeConfiguration: {
                                      ...prevHotel.feeConfiguration,
                                      cents: e.target.value,
                                    },
                                  }))
                                }
                                placeholder="Enter amount"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="my-2">
                    <Col>
                      <Form.Group controlId="formServices">
                        <Form.Label className="fw-semibold">
                          Services Selected :
                        </Form.Label>
                        <Row className="justify-content-center">
                          {SERVICE_DEFS.map(({ key, label }) => {
                            if (
                              key === "airbnb" &&
                              !(client?.model?.b2b || client?.model?.adminX)
                            ) {
                              return null;
                            }
                            const enabled = Boolean(
                              updatedHotel?.services?.[key]?.enabled,
                            );

                            return (
                              // <Col
                              //   key={key}
                              //   sm="auto"
                              //   className="border border-1 rounded-3 mx-3 py-3 px-4 my-1"
                              // >
                              //   <Form.Check
                              //     type="checkbox"
                              //     label={label}
                              //     checked={enabled}
                              //     onChange={() => toggleServiceEnabled(key)}
                              //   />
                              // </Col>
                              <Col
                                key={key}
                                sm="auto"
                                className="border border-1 rounded-3 mx-3 py-3 px-4 my-1"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label={label}
                                  checked={enabled}
                                  onChange={() => toggleServiceEnabled(key)}
                                />

                                {/* Pool Tips Switch */}
                                {enabled && (
                                  <div className="mt-2 border-top pt-2">
                                    <Form.Check
                                      type="switch"
                                      id={`pool-tip-switch-${key}`}
                                      label="Enable Pool Tips"
                                      checked={
                                        key === "valets"
                                          ? true
                                          : Boolean(
                                              updatedHotel?.services?.[key]
                                                ?.poolTipEnabled,
                                            )
                                      }
                                      disabled={key === "valets"}
                                      onChange={(e) => {
                                        if (key === "valets") return;

                                        setUpdatedHotel((prev) => ({
                                          ...prev,
                                          services: {
                                            ...prev.services,
                                            [key]: {
                                              ...prev.services[key],
                                              poolTipEnabled: e.target.checked,
                                            },
                                          },
                                        }));
                                      }}
                                    />
                                  </div>
                                )}
                              </Col>
                            );
                          })}
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                  {/*  Only show Botcopy Id if any service is enabled */}
                  {Object.values(updatedHotel?.services || {}).some(
                    (service) => service?.enabled,
                  ) && (
                    <Row>
                      <Col>
                        <Form.Group controlId="formBotcopyId">
                          <Form.Label className="fw-semibold">
                            Botcopy Bot Id :
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={updatedHotel.botcopyId}
                            onChange={(e) =>
                              setUpdatedHotel({
                                ...updatedHotel,
                                botcopyId: e.target.value,
                              })
                            }
                            placeholder="Please enter Botcopy Bot Id"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Form>
              </Col>
            </Row>
            {/* -------------------------------------------------- VALET LOCATIONS ---------------------------------------------- */}
            <Row>
              <Col>
                {updatedHotel.services?.valets && (
                  <Form.Group className="rounded-3 p-3 bg-light mt-3">
                    <Row className="mb-3">
                      <Col xs="auto">
                        <Form.Label>
                          Valet Locations
                          <span className="fst-italic fs-6 text-muted">
                            (Optional)
                          </span>
                        </Form.Label>
                      </Col>
                      <Col xs="auto" className="ms-auto">
                        <Button
                          className="rounded-4"
                          variant="outline-secondary"
                          onClick={() =>
                            setShowValetLocations(!showValetLocations)
                          }
                        >
                          <FontAwesomeIcon
                            icon={
                              showValetLocations ? faChevronUp : faChevronDown
                            }
                          />
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <Form.Control
                          type="text"
                          value={newLocationData.locationName}
                          onChange={(e) =>
                            setNewLocationData({
                              ...newLocationData,
                              locationName: e.target.value,
                            })
                          }
                          placeholder="Enter Location Name"
                        />
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          type="text"
                          value={newLocationData.hotelName}
                          onChange={(e) =>
                            setNewLocationData({
                              ...newLocationData,
                              hotelName: e.target.value,
                            })
                          }
                          placeholder="Enter Hotel Name"
                        />
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          type="text"
                          value={newLocationData.address}
                          onChange={(e) =>
                            setNewLocationData({
                              ...newLocationData,
                              address: e.target.value,
                            })
                          }
                          placeholder="Enter Address"
                        />
                      </Col>
                      <Col md={1}>
                        <Button
                          onClick={handleAddNewLocation}
                          className="rounded-3"
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> Add
                        </Button>
                      </Col>
                    </Row>
                    {valetLocationError && (
                      <span className="text-danger fst-italic fs-7 mx-2">
                        All feilds are required*
                      </span>
                    )}
                    {/* ----------------------------------------- VALET LOCATIONS --------------------------------- */}
                    <Row className="mt-2 p-3 w-100">
                      <Col
                        className={`transition ${
                          showValetLocations ? "visible" : "hidden"
                        }`}
                      >
                        {updatedHotel.valetLocations.length > 0 && (
                          <>
                            <Row>
                              <Col xs={2} className="text-break">
                                Location
                              </Col>
                              <Col xs={2} className="text-break">
                                Hotel Name
                              </Col>
                              <Col xs={3} className="text-break">
                                Address
                              </Col>
                              <Col xs={1} className="text-center">
                                QR code
                              </Col>

                              <Col xs={1} className="text-break ms-auto">
                                Delete
                              </Col>
                            </Row>
                          </>
                        )}
                        <div
                          style={{
                            maxHeight: "400px",
                            overflowX: "hidden",
                            overflowY: "auto",
                          }}
                        >
                          {updatedHotel.valetLocations.length > 0
                            ? updatedHotel.valetLocations.map(
                                (location, index) => (
                                  <div key={index}>
                                    <Row className="border border-1 rounded-4 p-1 my-2 bg-white align-items-center">
                                      <Col
                                        xs={2}
                                        className="fw-semibold  text-break"
                                      >
                                        {location.locationName}
                                      </Col>
                                      <Col xs={2} className="text-break">
                                        {location.hotelName}
                                      </Col>
                                      <Col xs={3} className="text-break">
                                        {location.address}
                                      </Col>
                                      <Col xs={1} className="text-break">
                                        <img
                                          style={{
                                            width: "70px",
                                            height: "70px",
                                          }}
                                          src={
                                            location.qrCode
                                              ? `${location.qrCode}`
                                              : "https://placehold.co/120x120?text=No+Image"
                                          }
                                          alt="QR code"
                                        />
                                      </Col>

                                      <Col
                                        xs={1}
                                        className="p-0 ms-auto justify-content-center d-flex"
                                      >
                                        <Button
                                          variant="outline-danger"
                                          className="border-1"
                                          onClick={() =>
                                            handleRemoveValetLocation(index)
                                          }
                                        >
                                          <FontAwesomeIcon
                                            // className="text-danger border-0 hover-effect"
                                            icon={faTrash}
                                          />
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                ),
                              )
                            : null}
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row className="my-4">
              <Col sm="auto" className="mx-auto">
                <Button
                  disabled={updateLoading}
                  className="px-2 ms-3 rounded-3"
                  variant="success"
                  type="submit"
                  onClick={() => handleEdit(false)}
                >
                  Save Changes
                </Button>

                {/* <Button
                  disabled={updateLoading}
                  className="px-2 ms-3 rounded-3"
                  variant="primary"
                  type="submit"
                  onClick={() => handleEdit(true)}
                >
                  Save and Email
                </Button> */}
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default EditClientDetails;
